import bannerAd from "../assets/ad.webp";

export function AdBanner() {
    return (
        <div className="w-100 d-flex align-items-center justify-content-center"
            style={{
                height: "95px",
                overflow: "hidden",
                borderRadius: "6px",
                background: "#fff",
            }}
        >
            {/* ✅ Option A — Google AdSense */}
            {/* <ins className="adsbygoogle"
                style={{ display: "block" }}
                data-ad-client="ca-pub-XXXXXXXXXXXXXXXX"
                data-ad-slot="XXXXXXXXXX"
                data-ad-format="auto"
                data-full-width-responsive="true"
            /> */}

            {/* ✅ Option B — your own banner image */}
            <a href="#" target="_blank" rel="noopener noreferrer" className="w-100 h-100 d-flex align-items-center justify-content-center">
                <img
                    src={bannerAd}
                    alt="Book Fair Advertisement" className="w-100 h-100"
                    style={{
                        objectFit: "cover",
                        display: "block"
                    }}
                />
            </a>

            {/* ✅ Option C — placeholder while setting up ads */}
            {/* <span className="text-muted small">Advertisement</span> */}
        </div>
    );
}